"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIcon = void 0;
const react_1 = __importDefault(require("react"));
const SearchIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M14.0962 14.0962C16.6346 11.5578 16.6346 7.44221 14.0962 4.90381C11.5578 2.3654 7.44221 2.3654 4.90381 4.90381C2.3654 7.44221 2.3654 11.5578 4.90381 14.0962C7.44221 16.6346 11.5578 16.6346 14.0962 14.0962Z", stroke: props.stroke, strokeWidth: "2" }),
        react_1.default.createElement("path", { d: "M14.9499 14.9497L20.9498 20.9497", stroke: props.stroke, strokeWidth: "2", strokeLinecap: "round" })));
};
exports.SearchIcon = SearchIcon;
